<template>
    <svg
        t="1729686127521"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="10017"
        width="20"
        height="20"
    >
        <path
            d="M960 512A448 448 0 1 0 64 512a448 448 0 0 0 896 0zM340.224 339.2a32 32 0 0 1 45.248 0.128L512 466.624l126.528-127.296a32 32 0 0 1 45.44 45.12L557.056 512l126.72 127.552a32 32 0 1 1-45.44 45.12L512.128 557.376l-126.528 127.296a32 32 0 0 1-45.44-45.12L466.944 512l-126.72-127.552a32 32 0 0 1 0.064-45.248z"
            fill="#d81e06"
            p-id="10018"
            data-spm-anchor-id="a313x.search_index.0.i8.6dae3a812YZxbe"
            class="selected"
        ></path>
    </svg>
</template>
